/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Target
 */
export interface Target {
    /**
     * 
     * @type {string}
     * @memberof Target
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Target
     */
    typeKey: string;
    /**
     * 
     * @type {string}
     * @memberof Target
     */
    categoryKey: string;
    /**
     * 
     * @type {number}
     * @memberof Target
     */
    gnwp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Target
     */
    nlr?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Target
     */
    rateChange?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Target
     */
    retentionRate?: number | null;
}

/**
 * Check if a given object implements the Target interface.
 */
export function instanceOfTarget(value: object): value is Target {
    if (!('typeKey' in value) || value['typeKey'] === undefined) return false;
    if (!('categoryKey' in value) || value['categoryKey'] === undefined) return false;
    return true;
}

export function TargetFromJSON(json: any): Target {
    return TargetFromJSONTyped(json, false);
}

export function TargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Target {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'typeKey': json['typeKey'],
        'categoryKey': json['categoryKey'],
        'gnwp': json['gnwp'] == null ? undefined : json['gnwp'],
        'nlr': json['nlr'] == null ? undefined : json['nlr'],
        'rateChange': json['rateChange'] == null ? undefined : json['rateChange'],
        'retentionRate': json['retentionRate'] == null ? undefined : json['retentionRate'],
    };
}

export function TargetToJSON(json: any): Target {
    return TargetToJSONTyped(json, false);
}

export function TargetToJSONTyped(value?: Target | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'typeKey': value['typeKey'],
        'categoryKey': value['categoryKey'],
        'gnwp': value['gnwp'],
        'nlr': value['nlr'],
        'rateChange': value['rateChange'],
        'retentionRate': value['retentionRate'],
    };
}

